import React from 'react'
import './css/header.css'
import { ChevronsRight} from "lucide-react";

export default function Header() {
  return (
    <div className='header-containerr'>
    <header className='header-name'>
    
    <h1>Featured</h1>
        <div>
          <ChevronsRight color="black" size={24} />
        </div>
      
    </header>
    </div>
  )
}